import { Injectable, signal } from '@angular/core';

export interface PageNavTab {
  key: string;
  label: string;
}

export interface PageNavConfig {
  title?: string | null;
  showBack?: boolean;
  tabs?: PageNavTab[];
  activeTab?: string | null;
}

@Injectable({ providedIn: 'root' })
export class PageNavService {
  private _title = signal<string | null>(null);
  private _showBack = signal(false);
  private _tabs = signal<PageNavTab[]>([]);
  private _activeTab = signal<string | null>(null);

  title = this._title.asReadonly();
  showBack = this._showBack.asReadonly();
  tabs = this._tabs.asReadonly();
  activeTab = this._activeTab.asReadonly();

  set(config: PageNavConfig): void {
    this._title.set(config.title ?? null);
    this._showBack.set(config.showBack ?? false);
    this._tabs.set(config.tabs ?? []);
    this._activeTab.set(config.activeTab ?? config.tabs?.[0]?.key ?? null);
  }

  setActiveTab(key: string): void {
    this._activeTab.set(key);
  }

  clear(): void {
    this._title.set(null);
    this._showBack.set(false);
    this._tabs.set([]);
    this._activeTab.set(null);
  }
}
